import { useAuthStore } from '@stores/auth';
import { useBannersStore } from '@stores/banners.js';
import { useSharedStore } from '@stores/shared.js';
import { useFiltersStore } from '@stores/filters.js';
import { useReportsStore } from '@stores/reports.ts';
import { useProductsStore } from '@stores/products.js';
import { useSettingsStore } from '@stores/settings.js';
import { useCausesStore } from '@stores/causes.js';
import { useFacilitiesStore } from '@stores/facilities.ts';
import { useLanguagesStore } from '@stores/languages.js';
import { useNotificationsStore } from '@stores/notifications.ts';
import { useAssetsStore } from '@stores/assets.ts';
import { useDefectsStore } from '@stores/defects.ts';
import { useDisconnectionsStore } from '@stores/disconnections';
import { useQualityEventsStore } from '@stores/qualityEvents';
import { useSensorsStore } from '@stores/sensors';
import { useDevicesStore } from '@stores/devices.ts';

/**
 * Resets all registered Pinia stores to their initial state.
 * Moved from @stores/index.js to prevent circular dependency.
 * TODO: There is a task to refactor this function responsible
 * for resetting all stores. This is prone to error when new stores
 * are added and this function is not updated.
 */
export const resetAllStoresUtil = () => {
    const stores = [
        useAuthStore,
        useBannersStore,
        useSharedStore,
        useFiltersStore,
        useReportsStore,
        useProductsStore,
        useSettingsStore,
        useCausesStore,
        useLanguagesStore,
        useNotificationsStore,
        useFacilitiesStore,
        useAssetsStore,
        useDefectsStore,
        useDisconnectionsStore,
        useQualityEventsStore,
        useSensorsStore,
        useDevicesStore
    ];

    stores.forEach(useStore => {
        const store = useStore();
        store.resetState();
    });
};
